import { render, staticRenderFns } from "./movilidad.vue?vue&type=template&id=6be8bf6d&"
import script from "./movilidad.vue?vue&type=script&lang=js&"
export * from "./movilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports